export default __webpack_public_path__ + "static/media/loss-analysis-step-4-finance.55d36c36.gif";